import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, withHandlers, lifecycle } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseButton from '../../components/atoms/CloseButton';
import GochiMenuDetailTableShopV2 from '../../components/molecules/GochiMenuDetailTableShopV2';

const styles = {
  root: {
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    top: '5%',
    backgroundColor: '#fff',
    padding: 20,
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4,
    color: '#000000'
  },
  margin: {
    margin: '20px 0 0 0'
  },
  scrollTable: {
    maxHeight: 296,
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  },
  titleDetail: {
    margin: '20px 0px 24px',
    textAlign: 'left',
    backgroundColor: '#fff',
    fontSize: 24,
    fontWeight: 700,
    color: '#000000'
  },
  btnClose: {
    fontSize: 14,
    fontWeight: 'bold'
  },
  selectControl: {
    width: '100%'
  },
  btnBox: {
    margin: '48px 0 20px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(dispatch => ({
    actions: bindActionCreators({}, dispatch)
  })),
  setPropTypes(propTypes),
  withHandlers({}),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(({ classes, detail, updateOpenDetailModal }) => {
  const closeAction = () => updateOpenDetailModal(false);

  return (
    <div className={classes.root}>
      <Typography className={classes.titleDetail}>メニュー詳細</Typography>
      <div>
        <GochiMenuDetailTableShopV2
          menuName={detail.menuName}
          menuId={detail.menuId}
          price={detail.price}
          taxTypeStr={detail.taxTypeStr}
          reducedTaxTypeStr={detail.reducedTaxTypeStr}
          description={detail.description}
          tags={detail.tags}
          comboMenu={detail.comboMenu}
          priceCombo={detail.priceCombo}
          quantityRelease={detail.quantityRelease}
          quantityPromotion={detail.quantityPromotion}
          promotionDescription={detail.promotionDescription}
          usageLimit={detail.usageLimit}
          expiration={detail.expiration}
          expirationEndDate={detail.expirationEndDate}
          image={detail.image}
          createdAt={detail.createdAt}
          updatedAt={detail.updatedAt}
          genreName={detail.menuGenreName}
          menuLimitTotal={detail.menuLimitTotal}
          usageType={detail.usageType}
          shopName={detail.shopName}
          taxType={detail.taxType}
        />
      </div>
      <div className={classes.btnBox}>
        <CloseButton className={classes.btnClose} onClickAction={closeAction} />
      </div>
    </div>
  );
});

export default withRouter(withStyles(styles)(Main));
